import { render, staticRenderFns } from "./contractEndWarning.vue?vue&type=template&id=5673689c&"
import script from "./contractEndWarning.vue?vue&type=script&lang=js&"
export * from "./contractEndWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports